@if (isLoading) {
  <ui-loading-spinner></ui-loading-spinner>
}

<div class="deposit-slip-detail-page">
  <span class="deposit-slip-detail-title body-medium-emphasized">
    {{ 'receipts.ui.dettaglioDistintaDiVersamento' | transloco }}
  </span>

  <div class="deposit-slip-detail-card">
    <div class="deposit-slip-summary deposit-slip-summary--mobile">
    <div class="deposit-slip-summary-row">
      <span class="body-large-emphasized">
        {{ 'receipts.ui.distintaN2' | transloco: { value0: (dettaglio.numeroDistinta) } }}
      </span>
      <span
        class="body-medium deposit-status-badge"
        [ngClass]="statusBadgeClass(dettaglio.situazione)"
      >
        {{ dettaglio.situazione }}
      </span>
    </div>

    <div class="deposit-slip-summary-row">
      <span class="body-small">{{ 'receipts.ui.data3' | transloco }}</span>
      <span class="body-small">{{ dettaglio.dataCreazione | date:'dd/MM/yyyy' }}</span>
    </div>

    <div class="deposit-slip-summary-row">
      <span class="body-small">{{ 'receipts.ui.totaleContanti3' | transloco }}</span>
      <span class="body-small">
        {{ dettaglio.riepilogo.totaleContanti | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
      </span>
    </div>

    <div class="deposit-slip-summary-row">
      <span class="body-small">{{ 'receipts.ui.totaleAssegni3' | transloco }}</span>
      <span class="body-small">
        {{ dettaglio.riepilogo.totaleAssegni | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
      </span>
    </div>

    <div class="deposit-slip-summary-row">
      <span class="body-large-emphasized">{{ 'receipts.ui.totaleAssegni3' | transloco }}</span>
      <span class="body-large-emphasized">
        {{ dettaglio.riepilogo.totaleDistinta | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
      </span>
    </div>
    </div>

    <div class="deposit-slip-summary deposit-slip-summary--desktop">
    <div class="deposit-slip-desktop-heading">
      <div class="deposit-slip-desktop-title">
        <span class="body-large-emphasized">
          {{ 'receipts.ui.riepilogoDistintaDiVersamentiN' | transloco: { value0: (dettaglio.numeroDistinta) } }}
        </span>
        <span
          class="body-medium deposit-status-badge"
          [ngClass]="statusBadgeClass(dettaglio.situazione)"
        >
          {{ dettaglio.situazione }}
        </span>
      </div>

      <span class="body-large-emphasized">
        {{ 'receipts.ui.totaleComplessivo3' | transloco: { value0: (dettaglio.riepilogo.totaleDistinta | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR') } }}
      </span>
    </div>

    <div class="deposit-slip-desktop-values">
      <div class="deposit-slip-desktop-value">
        <span class="body-small">{{ 'receipts.ui.data' | transloco }}</span>
        <span class="body-medium-emphasized">
          {{ dettaglio.dataCreazione | date:'dd/MM/yyyy' }}
        </span>
      </div>

      <div class="deposit-slip-desktop-value">
        <span class="body-small">{{ 'receipts.ui.totaleContanti' | transloco }}</span>
        <span class="body-medium-emphasized">
          {{ dettaglio.riepilogo.totaleContanti | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
        </span>
      </div>

      <div class="deposit-slip-desktop-value">
        <span class="body-small">{{ 'receipts.ui.totaleAssegni' | transloco }}</span>
        <span class="body-medium-emphasized">
          {{ dettaglio.riepilogo.totaleAssegni | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
        </span>
      </div>
    </div>
    </div>
  </div>

  <mat-tab-group
    animationDuration="0ms"
    class="deposit-slip-tabs"
    mat-align-tabs="start"
    (selectedIndexChange)="selectedTabIndex = $event"
  >
    <mat-tab [label]="'receipts.ui.verificaContanti' | transloco">
      <div class="deposit-slip-tab-content deposit-slip-general-mobile">
        @if (dettaglio.versamentiContanti.length > 0) {
          <div class="deposit-slip-general-section">
          <span class="title-medium-emphasized">
            {{ 'receipts.ui.elencoVersamentiInContante' | transloco }}
          </span>

          <div class="deposit-slip-general-card-list">
            @for (versamento of dettaglio.versamentiContanti; track versamento.idIncasso) {
              <div
                class="deposit-slip-general-card deposit-slip-cash-card"
                role="button"
                tabindex="0"
                [attr.aria-label]="(('receipts.ui.apriDistintaIncasso' | transloco) + ' ') + versamento.idIncasso"
                (click)="apriDettaglioContanti(versamento.idIncasso)"
                (keydown.enter)="apriDettaglioContanti(versamento.idIncasso)"
                (keydown.space)="$event.preventDefault(); apriDettaglioContanti(versamento.idIncasso)"
              >
              <div class="deposit-slip-general-card-data">
                <div class="deposit-slip-general-card-row body-medium-emphasized">
                  <span>{{ 'receipts.ui.incasso2' | transloco }}</span>
                  <span>{{ versamento.idIncasso }}</span>
                </div>
                <div class="deposit-slip-general-card-row body-medium">
                  <span>{{ 'receipts.ui.dataIncasso2' | transloco }}</span>
                  <span>{{ versamento.dataIncasso | date:'dd/MM/yyyy' }}</span>
                </div>
                <div class="deposit-slip-general-card-row body-medium">
                  <span>{{ 'receipts.ui.totaleMonete' | transloco }}</span>
                  <span class="body-medium-emphasized">
                    {{ versamento.totaleMonete | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
                  </span>
                </div>
                <div class="deposit-slip-general-card-row body-medium">
                  <span>{{ 'receipts.ui.totaleBanconote' | transloco }}</span>
                  <span class="body-medium-emphasized">
                    {{ versamento.totaleBanconote | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
                  </span>
                </div>
                <div class="deposit-slip-general-card-row body-medium-emphasized">
                  <span>{{ 'receipts.ui.totale3' | transloco }}</span>
                  <span>
                    {{ versamento.importoTotale | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
                  </span>
                </div>
              </div>

              <div class="deposit-slip-general-card-action" aria-hidden="true">
                <i class="fa-regular fa-chevron-right"></i>
              </div>
              </div>
            }
          </div>
          </div>
        } @else {
          <span class="deposit-slip-empty-state body-medium">{{ 'receipts.ui.nessunContanteDaVerificare' | transloco }}</span>
        }
      </div>

      <div class="deposit-slip-tab-content deposit-slip-general-desktop">
        @if (dettaglio.versamentiContanti.length > 0) {
          <div class="deposit-slip-general-desktop-section">
            <span class="title-medium-emphasized">{{ 'receipts.ui.elencoVersamentiInContante' | transloco }}</span>

            <ui-table-view
              [columnsInfo]="versamentiContantiColumns"
              [data]="versamentiContantiTable"
            />
          </div>
        } @else {
          <span class="deposit-slip-empty-state body-medium">{{ 'receipts.ui.nessunContanteDaVerificare' | transloco }}</span>
        }
      </div>

    </mat-tab>

    <mat-tab [label]="'receipts.ui.verificaAssegni' | transloco">
      <div class="deposit-slip-tab-content deposit-slip-general-mobile">
        @if (dettaglio.assegni.length > 0) {
          <div class="deposit-slip-general-section">
          <span class="title-medium-emphasized">{{ 'receipts.ui.elencoAssegniDaVerificare' | transloco }}</span>

          <div class="deposit-slip-general-card-list">
            @for (assegno of dettaglio.assegni; track assegno.id) {
              <div class="deposit-slip-general-card deposit-slip-check-card">
                <div class="deposit-slip-check-card-selection">
                  @if (assegno.verificato) {
                    <i
                      class="fa-regular fa-check deposit-slip-check-verified-icon"
                      [attr.aria-label]="(('receipts.ui.assegno' | transloco) + ' ') + assegno.numeroAssegno + (' ' + ('receipts.ui.verificato' | transloco))"
                    ></i>
                  } @else {
                    <mat-checkbox
                      *uiCan="CAPS.distintaVerifica"
                      [checked]="isAssegnoSelezionato(assegno.id)"
                      [attr.aria-label]="(('receipts.ui.selezionaAssegno' | transloco) + ' ') + assegno.numeroAssegno"
                      (change)="selezionaAssegno(assegno.id, $event.checked)"
                    />
                  }
                </div>

                <div class="deposit-slip-general-card-data">
                  <div class="deposit-slip-check-card-row body-medium-emphasized">
                    <span>{{ 'receipts.ui.assegnoN' | transloco: { value0: (assegno.numeroAssegno) } }}</span>
                    <span>
                      {{ assegno.importoTotale | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
                    </span>
                  </div>
                  <div class="deposit-slip-check-card-row body-medium">
                    <span>{{ 'receipts.ui.dataIncasso2' | transloco }}</span>
                    <span>{{ assegno.dataIncasso | date:'dd/MM/yyyy' }}</span>
                  </div>
                  <div class="deposit-slip-check-card-row body-medium">
                    <span>{{ 'receipts.ui.banca2' | transloco }}</span>
                    <span class="body-medium-emphasized">{{ assegno.banca }}</span>
                  </div>
                  <div class="deposit-slip-check-card-row body-medium">
                    <span>{{ 'receipts.ui.abi2' | transloco }}</span>
                    <span class="body-medium-emphasized">{{ assegno.abi }}</span>
                  </div>
                  <div class="deposit-slip-check-card-row body-medium">
                    <span>{{ 'receipts.ui.cab' | transloco }}</span>
                    <span class="body-medium-emphasized">{{ assegno.cab }}</span>
                  </div>
                </div>
              </div>
            }
          </div>
          </div>
        } @else {
          <span class="deposit-slip-empty-state body-medium">{{ 'receipts.ui.nessunAssegnoDaVerificare' | transloco }}</span>
        }
      </div>

      <div class="deposit-slip-tab-content deposit-slip-general-desktop">
        @if (dettaglio.assegni.length > 0) {
          <div class="deposit-slip-general-desktop-section">
          <span class="title-medium-emphasized">{{ 'receipts.ui.elencoAssegniDaVerificare' | transloco }}</span>

          <ui-table-view
            [columnsInfo]="assegniVerificaColumns"
            [data]="assegniTable"
          />
          </div>
        } @else {
          <span class="deposit-slip-empty-state body-medium">{{ 'receipts.ui.nessunAssegnoDaVerificare' | transloco }}</span>
        }
      </div>

    </mat-tab>

    <mat-tab [label]="'receipts.ui.versamento' | transloco">
      <div class="deposit-slip-tab-content deposit-slip-payment-content">
        <span class="deposit-slip-payment-title title-medium-emphasized">
          {{ 'receipts.ui.dettagliVersamento' | transloco }}
        </span>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ 'receipts.ui.banca' | transloco }}</mat-label>
          <mat-select [(ngModel)]="codBanca" [disabled]="versamentoReadOnly">
            @for (banca of banche; track banca.value) {
              <mat-option [value]="banca.value">{{ banca.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ 'receipts.ui.numeroOperazione' | transloco }}</mat-label>
          <input
            matInput
            [placeholder]="'receipts.ui.numeroRicevutaAtm' | transloco"
            [(ngModel)]="numeroOperazione"
            [disabled]="versamentoReadOnly"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ 'receipts.ui.data' | transloco }}</mat-label>
          <input
            matInput
            [matDatepicker]="depositDatePicker"
            [(ngModel)]="dataVersamento"
            [disabled]="versamentoReadOnly"
          />
          <mat-datepicker-toggle matIconSuffix [for]="depositDatePicker" [disabled]="versamentoReadOnly" />
          <mat-datepicker #depositDatePicker />
        </mat-form-field>

        @if (!chiusa) {
          @if (!ricevutaFile) {
            <span class="deposit-slip-payment-heading label-medium-emphasized">
              {{ 'receipts.ui.caricaLaRicevutaDiVersamento' | transloco }}
            </span>

            <div
              class="deposit-slip-upload-area"
              [class.deposit-slip-upload-area--disabled]="versamentoReadOnly"
              role="button"
              [attr.tabindex]="versamentoReadOnly ? -1 : 0"
              [attr.aria-disabled]="versamentoReadOnly"
              [attr.aria-label]="'receipts.ui.caricaUnaRicevutaPdfJpgOPng' | transloco"
              (click)="apriSelettoreFile(receiptFileInput)"
              (keydown.enter)="apriSelettoreFile(receiptFileInput)"
              (keydown.space)="$event.preventDefault(); apriSelettoreFile(receiptFileInput)"
              (dragover)="trascinaRicevuta($event)"
              (drop)="rilasciaRicevuta($event)"
            >
              <div class="deposit-slip-upload-icon" aria-hidden="true">
                <i class="fa-regular fa-arrow-up-from-bracket"></i>
              </div>

              <span class="body-medium">{{ 'receipts.ui.caricaLaRicevuta' | transloco }}</span>

              <span class="deposit-slip-upload-hint body-small">
                {{ 'receipts.ui.pdfJpgOPngMax10mb' | transloco }}
              </span>

              <input
                #receiptFileInput
                class="deposit-slip-upload-input"
                type="file"
                accept="application/pdf,image/jpeg,image/png,.pdf,.jpg,.jpeg,.png"
                [disabled]="versamentoReadOnly"
                (change)="selezionaRicevuta($event)"
              />
            </div>
          } @else {
            <section class="deposit-slip-attachments">
              <span class="label-medium-emphasized">{{ 'receipts.ui.ricevutaDiVersamento' | transloco }}</span>

              <div class="deposit-slip-attachments-grid">
                <div class="deposit-slip-attachment-card">
                  <div class="deposit-slip-attachment-icon" aria-hidden="true">
                    <i class="fa-regular fa-file-lines"></i>
                  </div>

                  <div class="deposit-slip-attachment-info">
                    <span class="body-medium-emphasized">{{ ricevutaFile.name }}</span>
                    <span class="body-small">
                      {{ 'receipts.ui.selezionatoIl' | transloco: { value0: (ricevutaFile.lastModified | date:'dd/MM/yyyy') } }}
                    </span>
                  </div>

                  <button
                    mat-icon-button
                    type="button"
                    class="deposit-slip-attachment-action"
                    [attr.aria-label]="(('receipts.ui.rimuovi' | transloco) + ' ') + ricevutaFile.name"
                    (click)="rimuoviRicevuta()"
                  >
                    <i class="fa-regular fa-xmark" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </section>
          }
        } @else {
          <section class="deposit-slip-attachments">
            <span class="label-medium-emphasized">{{ 'receipts.ui.ricevutaDiVersamento' | transloco }}</span>

            @if (dettaglio.allegati.length > 0) {
              <div class="deposit-slip-attachments-grid">
                @for (allegato of dettaglio.allegati; track allegato.id) {
                  <div class="deposit-slip-attachment-card">
                    <div class="deposit-slip-attachment-icon" aria-hidden="true">
                      <i class="fa-regular fa-file-lines"></i>
                    </div>

                    <div class="deposit-slip-attachment-info">
                      <span class="body-medium-emphasized">
                        {{ allegato.nomeFile || ('receipts.ui.documentoDiVersamento' | transloco) }}
                      </span>
                      @if (allegato.dataUpload) {
                        <span class="body-small">
                          {{ 'receipts.ui.caricatoIl' | transloco: { value0: (allegato.dataUpload | date:'dd/MM/yyyy') } }}
                        </span>
                      }
                    </div>

                    <button
                      mat-icon-button
                      type="button"
                      class="deposit-slip-attachment-action"
                      [attr.aria-label]="(('receipts.ui.scarica' | transloco) + ' ') + (allegato.nomeFile || ('receipts.ui.documentoDiVersamento2' | transloco))"
                      (click)="scaricaAllegato(allegato)"
                    >
                      <i class="fa-regular fa-arrow-down-to-line" aria-hidden="true"></i>
                    </button>
                  </div>
                }
              </div>
            } @else {
              <span class="deposit-slip-attachments-empty body-medium">
                {{ 'receipts.ui.nessunaRicevutaDiVersamentoDisponibile' | transloco }}
              </span>
            }
          </section>
        }

      </div>
    </mat-tab>
  </mat-tab-group>

  <div
    class="deposit-slip-detail-actions"
    [class.deposit-slip-detail-actions--payment]="selectedTabIndex === 2"
  >
    @switch (selectedTabIndex) {
      @case (0) {
        @if (haVersamentiContanti) {
          <button
            *uiCan="CAPS.distintaVerifica"
            matButton="filled"
            type="button"
            [disabled]="!inLavorazione || isSaving || !puoVerificare"
            (click)="verificaDistinta()"
          >
            {{ 'receipts.ui.conferma' | transloco }}
          </button>
        }
      }
      @case (1) {
        @if (haVersamentiAssegni) {
          @if (tuttiAssegniVerificati) {
            <button
              *uiCan="CAPS.distintaVerifica"
              matButton="filled"
              type="button"
              [disabled]="!inLavorazione || isSaving || !puoVerificare"
              (click)="verificaDistinta()"
            >
              {{ 'receipts.ui.conferma' | transloco }}
            </button>
          } @else {
            <button
              *uiCan="CAPS.distintaVerifica"
              matButton="filled"
              type="button"
              class="deposit-slip-confirm-checks-button"
              [disabled]="!inLavorazione || isSaving || !puoVerificare || !haAssegniSelezionati"
              (click)="verificaAssegni()"
            >
              {{ 'receipts.ui.confermaAssegni' | transloco }}
            </button>
          }
        } @else if (haVersamentiContanti) {
          <button
            *uiCan="CAPS.distintaVerifica"
            matButton="filled"
            type="button"
            [disabled]="!inLavorazione || isSaving || !puoVerificare"
            (click)="verificaDistinta()"
          >
            {{ 'receipts.ui.conferma' | transloco }}
          </button>
        }
      }
      @case (2) {
        @if (!chiusa) {
          <button
            *uiCan="CAPS.distintaChiudi"
            matButton="filled"
            type="button"
            [disabled]="!puoChiudere || isSaving"
            (click)="caricaEChiudi()"
          >
            {{ 'receipts.ui.caricaEChiudiVersamento' | transloco }}
          </button>
        }
      }
    }

    <button matButton="outlined" type="button" (click)="scaricaPdf()">
      {{ 'receipts.ui.scaricaPdf' | transloco }}
    </button>

    @if (inLavorazione) {
      <button
        matButton="outlined"
        type="button"
        class="deposit-slip-delete-button"
        *uiCan="CAPS.distintaElimina"
        [disabled]="isSaving"
        (click)="elimina()"
      >
        {{ 'receipts.ui.eliminaDistinta' | transloco }}
      </button>
    }
  </div>
</div>
